import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { IconButton } from '@wordpress/components';
/**
 * Internal dependencies
 */

import URLInput from '../url-input';
export default function LinkEditor(_ref) {
  var autocompleteRef = _ref.autocompleteRef,
      className = _ref.className,
      onChangeInputValue = _ref.onChangeInputValue,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["autocompleteRef", "className", "onChangeInputValue", "value"]);

  return createElement("form", _extends({
    className: classnames('block-editor-url-popover__link-editor', className)
  }, props), createElement(URLInput, {
    value: value,
    onChange: onChangeInputValue,
    autocompleteRef: autocompleteRef
  }), createElement(IconButton, {
    icon: "editor-break",
    label: __('Apply'),
    type: "submit"
  }));
}
//# sourceMappingURL=link-editor.js.map